import { FC } from 'react';

import {
  ActionBtnStyled,
  ControlsWrapStyled,
  FlexContainerMessageStyled,
  getPopupContentStyle,
} from './DeleteAttachmentPopup.styled';
import useDeleteAttachmentPopup from './hooks/useDeleteAttachmentPopup';
import ErrorSection from 'components/ErrorSection/ErrorSection';
import Popup from 'components/Popup/Popup';
import SuccessSection from 'components/SuccessSection/SuccessSection';
import Typography from 'components/Typography/Typography';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import { NoopT } from 'declarations/types/common';

type DeleteAttachmentPopupPropsT = {
  ticketId: string;
  fileName: string;
  originalName: string;
  isOpen: boolean;
  onClose: NoopT;
};

const DeleteAttachmentPopup: FC<DeleteAttachmentPopupPropsT> = ({
  ticketId,
  fileName,
  originalName,
  isOpen,
  onClose,
}) => {
  const { isMobile } = useResponsive();
  const {
    isDeletingAttachment,
    isAttachmentfullyDeleted,
    isAttachmentDeletionError,
    showPopupContent,
    handleDeleteAttachment,
    handleClosePopup,
    deleteAttachmentErrorMessage,
    deleteAttachmentValidationErrorMessage,
  } = useDeleteAttachmentPopup();

  return (
    <Popup
      nested
      isOpen={isOpen}
      showCloseBtn={isAttachmentfullyDeleted || isAttachmentDeletionError}
      popupId={ScrollLockIdE.DeleteAttachmentPopup}
      contentStyle={getPopupContentStyle(isMobile)}
      onClose={handleClosePopup(onClose)}
      closeOnEscape={false}
    >
      {showPopupContent && (
        <>
          <Typography color="darkBlue" variant="h2" align={isMobile ? 'center' : 'left'}>
            Are you sure you want to delete the attachment?
          </Typography>
          <ControlsWrapStyled justify={isMobile ? 'center' : 'flex-end'}>
            <ActionBtnStyled
              type="button"
              variant="outline"
              size="xl"
              onClick={handleClosePopup(onClose)}
            >
              Cancel
            </ActionBtnStyled>
            <ActionBtnStyled
              variant="contained"
              size="xl"
              isLoading={isDeletingAttachment}
              onClick={handleDeleteAttachment({ ticketId, fileName, originalName })}
            >
              Delete
            </ActionBtnStyled>
          </ControlsWrapStyled>
        </>
      )}

      {isAttachmentfullyDeleted && (
        <FlexContainerMessageStyled direction="column">
          <SuccessSection message="Attachment successfully deleted" />
        </FlexContainerMessageStyled>
      )}

      {isAttachmentDeletionError && (
        <FlexContainerMessageStyled direction="column">
          <ErrorSection
            errorDetails={deleteAttachmentErrorMessage || deleteAttachmentValidationErrorMessage}
          />
        </FlexContainerMessageStyled>
      )}
    </Popup>
  );
};

export default DeleteAttachmentPopup;
